import { render } from "./StatusByPassing.vue?vue&type=template&id=a483f02e&scoped=true"
import script from "./StatusByPassing.vue?vue&type=script&lang=js"
export * from "./StatusByPassing.vue?vue&type=script&lang=js"

import "./StatusByPassing.vue?vue&type=style&index=0&id=a483f02e&scoped=true&lang=css"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a483f02e"]])

export default __exports__